import '../styles/App.css'
import '../styles/AboutMe.css'

import { TargetAboutMe } from './ui/TargetAboutMe.jsx';
import { TargetStat } from './ui/TargetStat.jsx';

import iconQuienSoy from '../assets/icon-quien-soy.svg';
import iconMiCarrera from '../assets/icon-mi-carrera.svg';
import iconHobbies from '../assets/icon-hobbies.svg';

export function AboutMe(){
  return(
    <section id="about" className="about-me">
      <h3 className="title">Sobre mi</h3>
      <div className="about-me-content">

      <TargetAboutMe
        icon={iconQuienSoy}
        subtitle="¿Quién soy?"
        text={<p className="text">¡Hola! Soy Cristian Becerra, pero puedes llamarme <b>Bece</b>. Soy <b>Ingeniero Informático y de Sistemas</b> y <b>especialista en transformación digital</b> para instituciones públicas y privadas. Desde hace más de cinco años desarrollo, implanto y doy soporte a plataformas web, móviles y geoespaciales; buena parte de ese trabajo fue modernizar servicios municipales en Cusco.</p>}
      />

      <TargetAboutMe
        icon={iconMiCarrera}
        subtitle="Mi carrera"
        text={<p className="text">Me titulé como <b>Ingeniero Informático y de Sistemas</b> en la Universidad Nacional de San Antonio Abad del Cusco (UNSAAC), con quinto superior, y soy <b>egresado de la Maestría en Ciencias, mención Informática</b>. Estoy colegiado en el Colegio de Ingenieros del Perú (<b>CIP N.° 341115</b>).</p>}
      />

      <TargetAboutMe
        icon={iconHobbies}
        subtitle="Aprendizaje"
        text={<p className="text">Sigo formándome en <b>transformación digital y gestión pública</b>, <b>gobierno y gestión de servicios TI (ITIL 4 y COBIT)</b>, <b>ciberseguridad</b> e <b>ISO 27001</b>.</p>}
      />

      </div>

      <div className="about-me-stats">
        <TargetStat number="+5" label="años de experiencia en transformación digital y sistemas de información" />
        <TargetStat number="11" label="municipalidades de Cusco con sistemas implantados" />
        <TargetStat number="7" label="procesos censales y electorales como operador tecnológico" />
        <TargetStat number="INDECOPI" label="software de reservas registrado como coautor" />
      </div>
    </section>
  );
}
